module.exports = __webpack_public_path__ + "img/icon.f766746.png";